/**
 * Cart discount code form: apply code via Cart API and reload so B2G1 / discounts show.
 */
(function () {
  if (!window.routes || !window.routes.cart_update_url) return;

  function applyDiscountCode(form) {
    var input = form.querySelector('input[name="discount_code"]');
    var messageEl = form.querySelector('[data-discount-message]');
    var code = (input && input.value) ? input.value.trim() : '';
    if (!code) return;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }
    if (messageEl) {
      messageEl.setAttribute('aria-hidden', 'true');
      messageEl.textContent = '';
    }

    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount_codes: [code] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (result.ok && !result.data.message) {
          window.location.reload();
          return;
        }
        if (messageEl) {
          messageEl.setAttribute('aria-hidden', 'false');
          messageEl.textContent = result.data.message || (result.data.description || 'Discount could not be applied.');
        }
      })
      .catch(function () {
        if (messageEl) {
          messageEl.setAttribute('aria-hidden', 'false');
          messageEl.textContent = 'Something went wrong. Try again.';
        }
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  }

  function init() {
    document.querySelectorAll('.cart-discount-form').forEach(function (form) {
      if (form.dataset.discountFormInited) return;
      form.dataset.discountFormInited = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyDiscountCode(form);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
